import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './subscription-detail.html';
import closeIcon from './../../../images/close.png';
import upIcon from './../../../images/up.png';
import downIcon from './../../../images/down.png';
import alertIcon from './../../../images/alert.png';
import shippingOfferInfoIcon from './../../../images/shipping-info.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';

@
Component({
  controllerAs: 'subscriptionDetail', template
})
export default
class SubscriptionDetail {
  static $inject = ['$scope', '$ngRedux', 'spinnerService', 'authService', 'orderService', '$state', '$uibModal', '$stateParams', '$q', 'toaster','$anchorScroll','$location','$window', 'APP'
];

  constructor($scope, $ngRedux, $spinner, $auth, $order, $state, $uibModal, $stateParams, $q, toaster,$anchorScroll,$location, $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.dscMasterCode = '88888888'; // Named constant
    this.$auth = $auth;
    this.$state = $state;
    this.$order = $order;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.closeIcon = closeIcon;
    this.upIcon = upIcon;
    this.downIcon = downIcon;
    this.alertIcon = alertIcon;
    this.shippingOffer = {};
    this.min = new Date();
    this.shippingOffer.isOfferAvailable = false;
    this.shippingOffer.isOfferEligible = false;
    this.$stateParams = $stateParams;
    this.shippingOffer.thresholdAmount = 1500;
    this.shippingOfferInfoIcon = shippingOfferInfoIcon;
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
    this.cardId = "1";
    this.selectedFrequency = {};
    this.subStartDate = new Date();
    this.subMindate = "08-08-2017";
    this.$spinner = $spinner;
    this.toaster = toaster;
    this.freeShipping = {};
    this.subscriptionStatus = true;
    this.rateZoneRetryCount = 0;
    this.notDeliverable = false;
    // console.log(this.detail);

    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.$uibModal = $uibModal;
    $spinner.show('appSpinner');
    this.actionOption = $stateParams.option;
    var ctrl = this;
    this.subcriptionItemList = [];
    this.addressDetail = {};
    let userPromise, cartPromise = null;
    this.userShipingZonePromise = null;
    this.$order.getSubscriptionConfig();
   
    this.$window = $window;
    
   
    this.APP = APP;

   // angular.element(document.querySelectorAll('#tab-1')).trigger('click');
   // angular.element('#tab-1').trigger('click');

    userPromise = this.$auth.getUserProfile()
            .then(success => {

    let addressObj = localStorage.getItem('deliveryAddress');
    this.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
     if(!this.addressDetail.firstName){
            this.addressDetail.firstName = this.addressDetail.customer.firstName;
            this.addressDetail.lastName = this.addressDetail.customer.lastName;
      }
    this.calculateDeliveryOption();
  })
    ;
    if (this.$stateParams.option === 'add') {
      var items = ctrl.$auth.getSubscribedItems();
      if (items.length === 0) {
        cartPromise = $order.getOrderSummary($stateParams.subscriptionId)
                .finally(() => {
              $spinner.hide('appSpinner');
        ctrl.subcriptionItemList = ctrl.summaryDetail.orderEntries;
        ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
        ctrl.summaryDetail.orderEntries.forEach(function(entry) {
          ctrl.$auth.addToSubscriptionCart(entry.item, entry.quantity);
        });
      })
        ;
      } else {
        cartPromise = $order.getOrderSummary($stateParams.subscriptionId)
                .finally(() => {
              $spinner.hide('appSpinner');
        ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
        var localState = ctrl.$auth.getSubscriptionLocalState();
        ctrl.renderLocalState(localState);
      })
        ;
        this.subcriptionItemList = items.concat(this.subcriptionItemList);
      }
    } else { //   Edit part
       items = ctrl.$auth.getSubscribedItems();
      if (items.length === 0) {
        cartPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId)
                .finally(() => {
              $spinner.hide('appSpinner');
        ctrl.subcriptionItemList = ctrl.subscriptionDetail.subscriptionCart;
        if (ctrl.subscriptionDetail.status) {
          ctrl.subStartDate = new Date(ctrl.subscriptionDetail.startDate);
        }
        ctrl.freeShipping = ctrl.subscriptionDetail.freeshipping;
        ctrl.detail = ctrl.subscriptionDetail;
        ctrl.subscriptionStatus = ctrl.subscriptionDetail.status;
        ctrl.subcriptionItemList.forEach(function(entry) {
          ctrl.$auth.addToSubscriptionCart(entry.item, entry.quantity);

        });
        ctrl.cardId = ctrl.subscriptionDetail.userCard;
        ctrl.selectedFrequency = ctrl.detail.subscriptionInterval;
        ctrl.saveLocalState();
      })
        ;
      } else {
        cartPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId)
                .finally(() => {
              $spinner.hide('appSpinner');
        if (ctrl.subscriptionDetail.status) {
          ctrl.subStartDate = new Date(ctrl.subscriptionDetail.startDate);
        }
        ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
        var localState = ctrl.$auth.getSubscriptionLocalState();
        ctrl.renderLocalState(localState);

      })
        ;
        ctrl.subcriptionItemList = items.concat(ctrl.subcriptionItemList);
      }
    }
    if (cartPromise && userPromise) {
      let promises = [cartPromise, userPromise, this.userShipingZonePromise];
      $q.all(promises)
          .then(() => this.getTax()
    )
    .finally(() => $spinner.hide('appSpinner')
    )
      ;
    }
    if (!cartPromise) {
      let promises = [userPromise, this.userShipingZonePromise];
      $q.all(promises)
          .then(() => this.getTax()
    )
    .finally(() => $spinner.hide('appSpinner')
    )
      ;
    }
    /* let orderSummaryPromise = $order.getOrderSummary($stateParams.subscriptionId);*/
    $order.getAvailableSubscriptionsInterval()
        .finally(() => {
    if (!ctrl.selectedFrequency)
    {
      ctrl.selectedFrequency = ctrl.availableSubscriptionInterval[0];
    }
      $spinner.hide('appSpinner');
  }
  );

    $order.getPaymentInfo()
        .then(success => {
      if (this.$stateParams.option === 'add')
    {
      this.cardId = success.data[0];
    }
    else {
      var localState = ctrl.$auth.getSubscriptionLocalState();
      ctrl.renderLocalState(localState);
      this.cardId = ctrl.subscriptionDetail.userCard;
      this.saveLocalState();
      localState = ctrl.$auth.getSubscriptionLocalState();
      ctrl.renderLocalState(localState);

    }
        }
  )
  .finally(() => $spinner.hide('appSpinner')
  )
    ;
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile, /*    detail: state.order.cartDetail*/
      detail: state.order.subscriptionsDetail,
      cardInfo: state.order.paymentInfo,
      summaryDetail: state.order.orderDetail,
      subscriptionDetail: state.order.subscriptionsDetail,
      availableSubscriptionInterval: state.order.availableSubscriptionsInterval,
      userShippingZone: state.order.userShippingZone,
      taxes: state.order.taxes,
      subsConfig: state.order.subscriptionConfig
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  updateSubscription(item) {
    // console.log(this.subsConfig);
    var appTax = this.getTotalTax();
    var appSub = this.getSubtotal();
    var appTotal = Math.round((appSub + appTax) * 100) / 100;
    var todayDate = new Date();
    todayDate.setHours(0,0,0,0);
    var subSDate = new Date(this.subStartDate);
    subSDate.setHours(0,0,0,0);
    var allItems = item;
    let unSubscribedItems = allItems.filter(item => item.item.masterProduct.isSubscription === false);
    let outOfStockItems = allItems.filter(item => !this.isItemActive(item));
    if (outOfStockItems.length > 0)
    {
      this.toaster.pop('success', 'Please remove all out of stock products');
      return;
    }
    if (unSubscribedItems.length > 0)
    {
    this.toaster.pop('success', 'Please remove all unsubscribable products');
    return;
    }
    if (!this.subscriptionStatus && subSDate < todayDate)
    {
      this.openTab('subscribe-detail-tab');
      this.goToTab('subscribe-detail-tab');
      this.toaster.pop('success', 'Subscription  start date should be today or future date');
      return;
    }
    if (!this.selectedFrequency || !this.selectedFrequency.weeksInterval)
    {
      this.openTab('subscribe-detail-tab');
      this.goToTab('subscribe-detail-tab');
      this.toaster.pop('success', 'Please select frequency');
      return;
    }
    if (this.notDeliverable){
      this.openTab('delivery-tab');
      this.goToTab('delivery-tab');
      this.toaster.pop('success', 'Shipping address is not deliverable');
      return;
    }
    if (this.subsConfig.minSubcriptionAmt && appSub < this.subsConfig.minSubcriptionAmt) {
      this.toaster.pop('success', 'Subscription is only available if subtotal is minimum $' + this.subsConfig.minSubcriptionAmt);
      return;
    }
    if (!this.agreement) {

      this.openTab('payment-tab');
      this.goToTab('payment-tab');
      this.toaster.pop('success', 'Please agree terms & conditions to subscribe');
      return;
    }

      appTax = this.getTotalTax();
      appSub = this.getSubtotal();
      appTotal = Math.round((appSub + appTax) * 100) / 100;

      if (this.$stateParams.option === 'add'){
        item = allItems.map(function(item) {
          return {

            'item':{'id':item.item.id},
            'quantity':item.quantity
          };
        }); }



      var data = {
        "subscriptionInterval": {
          "id": this.selectedFrequency.id
        },
        "userCard": this.cardId,
        "subscriptionCart": item,
        "shipTo": {
          "addressLine1": this.addressDetail.shippingAddressLine1,
          "addressLine2": this.addressDetail.shippingAddressLine2,
          "city": this.addressDetail.shippingCity,
          "state": this.addressDetail.shippingState,
          "country": this.addressDetail.shippingCountry,
          "zip": this.addressDetail.shippingZipCode,
          "addressType": "Shipping",
          "deliveryType": "Next Day Delivery",
          "expectedDeliveryTime": "2017-7-11 7:0:25",
          "estimatedDeliveryDateTime": "2017-07-11T01:30:25.000Z",
          "phoneNumber": this.addressDetail.phoneNumber
        },
        "approximateShippingCost": +(this.getSelectedShipmentCharge()).toFixed(2) || 0,
        "approximateShippingdiscount": 0,
        "approximateTotal": appTotal,
        "startDate": this.convertDate(this.subStartDate,'ymd'),
        "approximateSubTotal": this.getSubtotal(), /* "approximateSubTotal":58.32,*/
        "approximateTax": this.getTotalTax()
      };
      if (this.$stateParams.option === 'edit') {
        data.id = this.detail.id;
      }
      this.$spinner.show('appSpinner');
      this.$order.updateSubscriptionsDetail(data)
          .then(success => { this.$spinner.hide('appSpinner');
      this.toaster.pop('success', success.data.message.split(',')[0]);
      this.$state.go('subscription-success',{'subscriptionId':success.data.additionalInfo});
    })
    .catch(() => { this.toaster.pop('success', 'Error in Subscription Update');
      this.$spinner.hide('appSpinner');

    })
      ;


  }



  getTotalAmount() {

      return +(this.getSelectedShipmentCharge() + this.getSubtotal() + this.getTotalTax()).toFixed(2);

  }

  changeFrequency() {
    if (this.subscriptionStatus) {
      this.subStartDate = new Date();
    }
    this.subscriptionStatus = false;
    this.saveLocalState();
  }

  getRetailPrice(quantity, price) {
    return quantity * price;
  }

  getClubDiscount(quantity, price) {
    return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
  }

  getDiscountedPrice(quantity, price) {
    return quantity * (Math.round((0.85 * price) * 100) / 100);
  }

  totalRetailPrice() {
    return this.subcriptionItemList.map(item => item.item.price * item.quantity
  )
  .reduce((prev, curr) => prev + curr
  )
    ;
  }

  getSubtotal() {
    let totalPrice = 0;
    if (this.isDscMember() || this.cartContainsDsc()) {
      // console.log(this.subcriptionItemList);
      let dscItems = this.subcriptionItemList.filter(item => item.item.masterProduct.subCategories[0].category.dscCategory
    )
      ;
      let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      let nondscItems = this.subcriptionItemList.filter(item => !item.item.masterProduct.subCategories[0].category.dscCategory
    )
      ;
      let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      totalPrice = dscTotal + nonDscTotal;
    } else {
      totalPrice = this.totalRetailPrice();
    }
    return totalPrice;
  }

  getTotalSaving() {
    return this.totalRetailPrice() - this.getSubtotal();
  }

  // DSC Points is equal to subtotal (Price - discount).
  getDscPoints() {
    return this.getSubtotal();
  }

  // totalDSC() {
  //   if (this.isDscMember()) {
  //     let dscItems = this.detail.cartItems.filter(item => item.item.subCategory.category.dscCategory);
  //     let totalPrice = dscItems.map(item => item.item.price * item.quantity)
  //       .reduce((prev, curr) => prev + curr, 0);
  //     return totalPrice * 15 / 100; // Discount is 15 percent
  //   }
  //   return 0;
  // }
  // getSubtotal() {
  //   return this.totalPrice() - this.totalDSC();
  // }
  updateItemInCart(quantity, itemId) {
    var tempItems = this.$auth.getSubscribedItems();
    for (var i = 0; i < tempItems.length; i++) {
      if (tempItems[i].item.id === itemId) {
        tempItems[i].quantity = quantity;
        break;
      }
    }
    this.$auth.setSubscribedItems(tempItems);
    this.subcriptionItemList = tempItems;
    this.getTax();
  }

  removeItemFromCart(itemId) {
    var tempItems = this.$auth.getSubscribedItems();
    for (var i = 0; i < tempItems.length; i++) {
      if (tempItems[i].item.id === itemId) {
        tempItems.splice(i, 1);
        break;
      }
    }
    this.$auth.setSubscribedItems(tempItems);
    this.subcriptionItemList = tempItems;
    this.getTax();
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }


  isAnyItemInactive() {
    var arr = [];
    if (this.subcriptionItemList) {
      arr = this.subcriptionItemList.filter(item => !(item.item.isActive && item.item.masterProduct.isActive && (item.item.price >= item.item.regionalPrice))
    );
    }
    return !(arr.length === 0);
  }

  goToDetailPage(item) {

    if (this.isItemDscMembership(item)) {
      this.$state.go('savings-club');
    } else {
      this.$state.go('product.detail', {
        categoryId: item.subCategory.category.id, subCategoryId: item.subCategory.id, productId: item.item.masterProduct.id
      });
    }
  }

  isItemDscMembership(item) {
    return item.item.masterProduct.masterCode === this.dscMasterCode;
  }

  isItemActive(item) {
    return (item.item.isActive && item.item.masterProduct.isActive && (item.item.price >= item.item.regionalPrice));
  }

  getShippingDiscountCharge() {
    if (this.freeShipping) {
      if (this.freeShipping.zone && this.isShippingDiscountEligible()) {
        // console.log(this.freeShipping.zone.nextDayCharge);
        return this.freeShipping.zone.nextDayCharge;
      }
    }
    return 0;
  }

  isShippingDiscountEligible() {
    let grossPrice = this.shippingGrossPrice();
    var res = false;
    var result = false;
    if (!this.notDeliverable && this.profile.store && this.freeShipping) {
      res = ((this.profile.store.isFreeShipping ) && (grossPrice >= this.freeShipping.thresholdValue));
      var shippingOfferStartDate = new Date(this.freeShipping.startDate);
      var shippingOfferEndDate = new Date(this.freeShipping.endDate);
      var currentDate = new Date();
      // console.log(shippingOfferStartDate - currentDate);
      // console.log(shippingOfferEndDate - currentDate);
      if (res) {
        if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
          result = true;
        }
      }
    }
    return result;
  }

  shippingGrossPrice() {
    return this.subtotal();
  }

  isFreeShippingOfferAvailable() {
    if (this.profile && this.freeShipping) {
      var shippingOfferStartDate = new Date(this.freeShipping.startDate);
      var shippingOfferEndDate = new Date(this.freeShipping.endDate);
      var currentDate = new Date();
      var result = false;
      if (this.profile.store) {
        if (this.profile.store.isFreeShipping) {
          if (parseInt(currentDate) >= parseInt(shippingOfferStartDate) && parseInt(currentDate) <= parseInt(shippingOfferEndDate)) {
            result = true;
          }
        }
      }
    }
    return result;
  }

  getFreeShippingRemainingAmount() {
    if (this.detail) {
      if (this.freeShipping) {
        this.shippingOffer.thresholdAmount = this.freeShipping.thresholdValue;
      }
    }
    let remainingAmount = this.getSubtotal() - this.shippingOffer.thresholdAmount;
    if (remainingAmount >= 0) {
      this.shippingOffer.isOfferEligible = true;
    } else {
      this.shippingOffer.isOfferEligible = false;
    }
    return remainingAmount * -1;
  }

  showFreeShippingOfferDetail() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>';
      tittle = 'Shipping offer is Eligible';
    } else {
      tittle = 'Shipping offer is available';
      detailInfo = '<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
                '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo +
                '</div>' +
                '<div class="modal-footer">' +
                '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance', function($scope, $order, $uibModalInstance) {
        $scope.ok = () =>
        {
          $uibModalInstance.close();
        }
        ;
      }]
    });
  }

  addProduct() {
    var info = {'id': this.$stateParams.subscriptionId, 'option': this.$stateParams.option};
    this.saveLocalState();
    this.$auth.setSubscribedInfo(info);
    this.$state.go('subscribable-products');
  }

  addTempSubcribedCartItems() {
    var tempItems = this.$auth.getSubscribedItems();
    this.subcriptionItemList = tempItems.concat(this.subcriptionItemList);
  }

  calculateDeliveryOption() {

    //  // console.log(profile);
    var addressInfo = {
      'addressLine1': this.addressDetail.shippingAddressLine1, 'city': this.addressDetail.shippingCity, 'state': {
        'code': this.addressDetail.shippingState.code
      }, 'zip': this.addressDetail.shippingZipCode, 'country': this.addressDetail.shippingCountry
    };
    var ctrl = this;
    ctrl.rateZoneRetryCount++;
    this.userShipingZonePromise = this.$order.getUserZone(addressInfo).then(() => {
      this.notDeliverable = false;
    this.getTax();
  },
    error => {

      if (error.data.errorCode === 200) {
        if (ctrl.rateZoneRetryCount <= 3) {
          ctrl.calculateDeliveryOption();
        }
        else {
          ctrl.notDeliverable = true;
        }
      }
      else  {
        ctrl.notDeliverable = true;
      }
    }
  )
    ;
  }

  ChangeShippingAddress() {
    var info = {'id': this.$stateParams.subscriptionId, 'option': this.$stateParams.option, 'addressChange': true};
    this.$auth.setSubscribedInfo(info);
    this.$state.go('delivery.address');
  }

  getSelectedShipmentCharge() {
    if (this.userShippingZone) {
      return this.userShippingZone.nextDayCharge;
    }
    return 0;
  }

  cartContainsDsc() {
    return this.subcriptionItemList ? this.subcriptionItemList.filter(item => {
      return item.item.masterProduct.masterCode === this.dscMasterCode;
  }).length  : false;
  }

  cartContainsOnlyDsc() {
    const totalItemsInCart = this.subcriptionItemList.length;
    return this.cartContainsDsc() && (totalItemsInCart === this.cartContainsDsc());
  }



  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  taxableAmount() {
    let totalTaxablePrice = 0;
    if (this.isDscMember() || this.cartContainsDsc()) {
      let dscItems = this.subcriptionItemList && this.subcriptionItemList.filter(item => item.item.masterProduct.subCategories[0].category.dscCategory
    )
      ;
      let nondscItems = this.subcriptionItemList && this.subcriptionItemList.filter(item => !item.item.masterProduct.subCategories[0].category.dscCategory
    )
      ;
      let taxableDscItems = dscItems.filter(item => item.item.taxable
    )
      ;
      let taxableNonDscItems = nondscItems.filter(item => item.item.taxable
    )
      ;
      let taxableDscAmount = taxableDscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      let taxableNonDscAmount = taxableNonDscItems.map(item => item.item.price * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      totalTaxablePrice = taxableDscAmount + taxableNonDscAmount;
    } else {
      let taxableItems = this.subcriptionItemList && this.subcriptionItemList.filter(item => item.item.taxable
    )
      ;
      let taxablePrice = taxableItems.map(item => item.item.price * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      totalTaxablePrice = taxablePrice;
    }
    return totalTaxablePrice;
  }

  retailPrice() {
    return this.subcriptionItemList && this.subcriptionItemList.map(item => item.item.price * item.quantity
  )
  .reduce((prev, curr) => prev + curr, 0
  )
    ;
  }

  subtotal() {
    let totalPrice = 0;
    if (this.isDscMember() || this.cartContainsDsc()) {
      let dscItems = this.subcriptionItemList && this.subcriptionItemList.filter(item => item.subCategory.category.dscCategory
    )
      ;
      let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      let nondscItems = this.subcriptionItemList && this.subcriptionItemList.filter(item => !item.subCategory.category.dscCategory
    )
      ;
      let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity
    )
    .reduce((prev, curr) => prev + curr, 0
    )
      ;
      totalPrice = dscTotal + nonDscTotal;
    } else {
      totalPrice = this.retailPrice();
    }
    return totalPrice;
  }

  getTax() {

    // console.log('this.taxableAmount()---', this.taxableAmount());
    // console.log('this.taxableAmount()---', this.subtotal());
    // console.log('this.getSelectedShipmentCharge()---', this.getSelectedShipmentCharge());
    var data;
    if (this.getSelectedShipmentCharge()) {
       data = {
        'shipTo': {
          'addressLine1': this.addressDetail.shippingAddressLine1,
          'addressLine2': this.addressDetail.shippingAddressLine2,
          'city': this.addressDetail.shippingCity,
          'state': this.addressDetail.shippingState,
          'country': this.addressDetail.shippingCountry,
          'zip': this.addressDetail.shippingZipCode,
          'addressType': 'Shipping',
          'deliveryType':'Home Delivery',
          'expectedDeliveryTime': '',
          'estimatedDeliveryDateTime': '',
          'phoneNumber': this.addressDetail.phoneNumber
        },
         'totalAmount' : this.getSubtotal(),
        'taxableAmount': this.taxableAmount(),
        'shippingCharge': this.getSelectedShipmentCharge(),
        'discount': 0
      };
      this.isCallingAPI = true;
      this.$order.calculateTaxes(data)
          .then(success => {
          // console.log("success",success);
        if (this.taxes.tax.amountToCollect >= 0)
      {
        this.isCallingAPI = false;
        var localState = this.$auth.getSubscriptionLocalState();
        this.renderLocalState(localState);
      }
    },
    error => {
        // console.log("taxError",error);
        this.toaster.pop('success', 'Error in tax calculation');
    })
    .catch(error => {}
        // console.log("taxError",error)
    );
    }
  }

  getTotalTax() {
    if (this.taxes.tax) {
      return this.taxes.tax.amountToCollect;
    }
    return 0;

  }

  convertDate(date, format) {
    if (date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();
      if (month < 10) {
        month = '0' + month.toString();
      }
      if (day < 10) {
        day = '0' + day.toString();
      }
      var cdate = null;
      if (format === 'dmy') {
        cdate = day + '-' + month + '-' + year;
      } else if (format === 'ymd') {
        cdate = year + '-' + month + '-' + day;
      } else {
        cdate = month + '-' + day + '-' + year;
      }
      return cdate;
    }
    return null;
  }
  saveLocalState(){
    var localState = {};
    localState.selectedFrequency = this.selectedFrequency;
    localState.subStartDate = this.subStartDate;
    localState.agreement = this.agreement;
    localState.cardId = this.cardId;

    this.$auth.saveSubscriptionLocalState(localState);

  }
  renderLocalState(localState){
    var savedCard = (localState.cardId) ? localState.cardId : {};
    var ctrl = this;
    angular.forEach(this.cardInfo,function(card){
    if (card.id === savedCard.id) {
      ctrl.cardId = card;
    }
    });
    this.selectedFrequency = (localState.selectedFrequency) ? localState.selectedFrequency : {};
    this.subStartDate = (localState.subStartDate) ? new Date(localState.subStartDate) : new Date();
    this.agreement = (localState.agreement) ? localState.agreement : false;
  }
  openTab(id){
  var isChecked = document.getElementById(id).checked;
    if (!isChecked) { // if it not checked open the tab
      document.getElementById(id).click();

    }
  }
  goToTab(id){
    if (this.$location.hash() !== id ) {
      this.$location.hash(id);
    }
    else {
      this.$anchorScroll();
    }
  }
  discardSubscription(){
    this.$auth.resetSubscriptionCart();
    this.$state.go('subscription');
  }
}



// WEBPACK FOOTER //
// ./src/app/order/subscription-detail/subscription-detail.js